import React, { useState } from "react";
import { formatNumber } from "utils/currencyFormat";
import { ModalChiTietPhiKhac } from "./ModalChiTietPhiKhac";

export const BtnChiTietPhiKhac = ({ item }) => {
  const [show, setShow] = useState(false);

  if (!item.OtherFee) {
    return <>{formatNumber(item.OtherFee)}</>;
  }
  return (
    <>
      <a
        onClick={() => setShow(true)}
        href={() => false}
        className="blue btn-link"
      >
        {formatNumber(item.OtherFee)}
      </a>
      {show && (
        <ModalChiTietPhiKhac
          show={show}
          onHide={() => setShow(false)}
          item={item}
        />
      )}
    </>
  );
};
